import http from "./http";

class PanierService {
    index(){
        return http.get("/api/cart")
    }

    store(data){
        return http.post("/api/cart/store", data)
    } 
}

export default new PanierService()